import React from "react";
import { useLessonDetails } from "../../hooks/useLessonDetails";
import LessonCartaView from "./lessons/LessonCartaView";
import LessonView from "./LessonView";

const LessonViewMiddleware = ({ courseId, episodeId, chapterId, ...props }) => {
  const userId = props.userId;
  const lessonId = props.id;

  const lesson = useLessonDetails(lessonId);
  const lessonType = Object.keys(lesson?.data || {})[0] || lesson?.type;

  if (lessonType === "LESSON_CARTA")
    return (
      <LessonCartaView
        courseId={courseId}
        episodeId={episodeId}
        chapterId={chapterId}
        lessonId={lessonId}
        userId={userId}
      />
    );
  else return <LessonView {...props} />;
};


export default LessonViewMiddleware;
